import React from 'react';
import { useEditorWatch, useActions } from '../../../../provider';
import BaseBlock from '../BaseBlock';

const BaseGroupBlock = ({ evtName, getNewState, items, isActive }) => {
  const { getEditorState, onChange } = useActions();

  const watchedValue = useEditorWatch(evtName);

  const handleClick = (value) => {
    onChange(getNewState(getEditorState(), value));
  };

  return items.map((props) => (
    <BaseBlock
      {...props}
      key={props.inlineStyle}
      onClick={handleClick}
      active={isActive(watchedValue, props.inlineStyle)}
    />
  ));
};

export default BaseGroupBlock;
